"use strict";

const EventEmitter = require('events').EventEmitter;
//const _ = require('lodash');
const Renderer = require("./DefaultColumnRenderer");

class DefaultColumnComponent extends EventEmitter {

    constructor(value) {
        super();

        this.setMaxListeners(0);

        this._value = value;

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._value = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/


    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setValue(newVal){
        this._value = newVal;
        this.emit('Value', this._value);
        return this;
    }
    getValue(){
        return this._value;
    }
    
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = DefaultColumnComponent;